import { MAX_TEXT_LENGTH } from "../protocol/constants.js";
import { messageEnvelopeSchema } from "../protocol/message-envelope.js";
import { spaceMessageFileReferencesSchema } from "./space-files.js";
import { signalTextEnvelopeSchema } from "../protocol/envelope.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-message-mutation.ts
const SPACE_MESSAGE_CHANGED_PURPOSE = "space_message_changed";
const spaceMessageMutationBodySchema = z$1.discriminatedUnion("action", [
	z$1.strictObject({
		action: z$1.literal("edit"),
		expectedRevision: z$1.number().int().nonnegative(),
		text: z$1.string().max(MAX_TEXT_LENGTH),
		retainedFileIds: z$1.array(z$1.string().min(1)).optional(),
		retainedAttachmentIds: z$1.array(z$1.string().min(1)).optional(),
		messageEnvelope: messageEnvelopeSchema.optional(),
		addedFiles: spaceMessageFileReferencesSchema.optional()
	}),
	z$1.strictObject({
		action: z$1.literal("recall"),
		expectedRevision: z$1.number().int().nonnegative()
	}),
	z$1.strictObject({ action: z$1.literal("restore_draft") })
]);
const spaceMessageMutationResponseSchema = z$1.strictObject({ message: signalTextEnvelopeSchema });
//#endregion
export { SPACE_MESSAGE_CHANGED_PURPOSE, spaceMessageMutationBodySchema, spaceMessageMutationResponseSchema };

//# sourceMappingURL=space-message-mutation.js.map